import {Suspense} from 'react';
import clsx from 'clsx';
import {Outlet, useLoaderData} from 'react-router';
import {twMerge} from 'tailwind-merge';
import AppShell from '@/components/app-shell';
import ApplicationHeader from '@/components/application-header';
import NewDocumentCreation, {NewDocumentCreationProvider} from '@/components/new-document-creation';
import {AuthenticationProvider} from '@/contexts/authentication';
import {ConfigProvider} from '@/contexts/config';
import {useNetworkStatus} from '@/contexts/network-status-context';
import {UserProfileContextProvider} from '@/contexts/user-profile';
import {useNonFormPageViewEvent} from '@/hooks/analytics/use-non-form-page-view-event';
import {useUserRolePropertyEvent} from '@/hooks/analytics/use-user-role-property-event';
import type {LoaderData} from './loader';

function App() {
  const {config, user, userProfile} = useLoaderData<LoaderData>();
  const {isOffline} = useNetworkStatus();

  useUserRolePropertyEvent(userProfile.advisorRole);
  useNonFormPageViewEvent(user.profile.sub, userProfile.advisorRole);

  return (
    <AuthenticationProvider user={user}>
      <UserProfileContextProvider profile={userProfile}>
        <AppShell>
          <ConfigProvider config={config}>
            <NewDocumentCreationProvider>
              <ApplicationHeader profile={userProfile} />

              <div className={twMerge(clsx('relative flex w-full', isOffline && 'opacity-20'))}>
                <Outlet />
              </div>

              <Suspense>
                <NewDocumentCreation />
              </Suspense>
            </NewDocumentCreationProvider>
          </ConfigProvider>
        </AppShell>
      </UserProfileContextProvider>
    </AuthenticationProvider>
  );
}

export default App;
